import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError, GetListResponse } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { ProductComment } from "../../product.types";
import { requestGetProductComments } from "./getProductComments.request";
import { GetProductCommentsRequestParams } from "./getProductComments.types";

const useGetProductComments = (
  requestParams: GetProductCommentsRequestParams,
  options?: QueryOptions<
    GetListResponse<ProductComment>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["admin", "products", "reviews", requestParams],
    queryFn: async () => await requestGetProductComments(requestParams),
    onError: toastServerError,
    ...options
  });

  return {
    comments: data?.data,
    meta: data?.meta,
    ...rest
  };
};

export default useGetProductComments;
